import { render, staticRenderFns } from "./feedbacks.vue?vue&type=template&id=db5f0ac2&scoped=true&"
import script from "./feedbacks.vue?vue&type=script&lang=js&"
export * from "./feedbacks.vue?vue&type=script&lang=js&"
import style0 from "./feedbacks.vue?vue&type=style&index=0&id=db5f0ac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5f0ac2",
  null
  
)

export default component.exports